import { render, staticRenderFns } from "./xjzzdform.vue?vue&type=template&id=c3fad580&scoped=true&"
import script from "./xjzzdform.vue?vue&type=script&lang=js&"
export * from "./xjzzdform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fad580",
  null
  
)

export default component.exports